import React from "react";
import axios from "axios";
import { Header, Footer } from "@/components";
import SolutionsDetailsPage from "@/components/solution-details";

function SolutionDetails({ solutionData, relatedSolutionsData }) {
  return (
    <>
      <Header />
      <main>
        <SolutionsDetailsPage
          solutionData={solutionData}
          relatedSolutionsData={relatedSolutionsData}
        />
      </main>
      <Footer />
    </>
  );
}

export async function getServerSideProps({ params, res }) {
  try {
    const solutionsRes = await axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/nivalabs/solutions/${params.slug}/`,
      {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    const relatedSolutionsRes = await axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/nivalabs/solutions/${params.slug}/related_solutions/`,
      {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }
    );

    if (!solutionsRes?.data) {
      return { notFound: true };
    }

    res.setHeader(
      "Cache-Control",
      "public, s-maxage=600, stale-while-revalidate=86400",
    );

    return {
      props: {
        solutionData: solutionsRes.data,
        relatedSolutionsData: Array.isArray(relatedSolutionsRes.data)
          ? relatedSolutionsRes.data.slice(0, 6)
          : [],
      },
    };
  } catch (error) {
    console.error("Error fetching solution:", error);
    if (error?.response?.status === 404) {
      return { notFound: true };
    }
    return {
      props: {
        solutionData: null,
        relatedSolutionsData: [],
      },
    };
  }
}

export default SolutionDetails;
